import { Component, OnInit, ViewEncapsulation, SimpleChanges, OnChanges, Input } from '@angular/core';
import { Vraag, Antwoord, ValidatieParameter } from '@models/claims';
import { VraagboomEmptyResultaat, Verzekering, Meetgegevens } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { ValidatieregelHelper } from '@services/public_api';
import { MetenMapper } from '../../../mappers/meten.mapper';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MultiselectComponent extends BaseVraagControlDirective<VraagboomEmptyResultaat> implements OnInit, OnChanges {
  minChoices = 0;
  maxChoices = 0;
  inGroepen = false;
  groepen: Antwoord[];
  selectedIds: string[] = [];
  _verzekering: Verzekering;
  _meetgegevens: Meetgegevens;

  @Input() isCurrentVraag: boolean;

  constructor(_dataService: DataService) {
    super(_dataService);
  }

  ngOnInit() {
    this._verzekering = this._dataService.getVerzekering();
    this._meetgegevens = this._dataService.getMeetgegevens();
  }

  initialize(changes: SimpleChanges): void {
    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null && this.antwoordResultaat.antwoorden != null) {
      this.selectedIds = this.antwoordResultaat.antwoorden.map(a => a.id);
    }

    if (this.vraag) {
      const minMaxNumberValidator: ValidatieParameter = ValidatieregelHelper.get(this.vraag.validatieParameters, 'MIN_MAX');
      if (minMaxNumberValidator != null) {
        const params = minMaxNumberValidator.validatie_parameters.split(';');
        if (params?.length > 1) {
          this.minChoices = Number(params[0]);
          this.maxChoices = Number(params[1]);
        }
      }

      if (this.vraag.antwoorden?.length > 0 && this.vraag.antwoorden[0].groep_id?.length > 0) {
        this.inGroepen = true;
        let groepId = '';
        this.groepen = [];

        this.vraag.antwoorden.forEach((antw: Antwoord) => {
          if (antw.groep_id !== groepId) {
            this.groepen.push(antw);
            groepId = antw.groep_id;
          }
        });
      }
    }
  }

  geefMeetidMulti(vraagtitel: string, antwoordtitel: string): string {
    if (this._meetgegevens == null) {
      return '';
    }

    return 'ipoclick-checkbox-' + this._dataService.getMeetidPazaProces() + '-' +
      this._meetgegevens.status + this._meetgegevens.sleutel +
      MetenMapper.geefVolgnr(this.vraag, this._meetgegevens.reeks) + '_' +
      MetenMapper.format(this._verzekering.sleutel) + '-' +
      MetenMapper.format(vraagtitel) + '-' + MetenMapper.format(antwoordtitel);
  }

  multiselectClicked(antwoord: Antwoord) {
    if (!this.isCurrentVraag) {
      return;
    }

    if (!this.selectedIds) {
      this.selectedIds = [];
    }

    if (this.selectedIds.indexOf(antwoord.id) >= 0) {
      this.selectedIds = this.selectedIds.filter(id => id !== antwoord.id);
    } else {
      if (this.selectedIds.length >= this.maxChoices)
        return;

      this.selectedIds.push(antwoord.id);
    }

    this.notifyAntwoord();
  }

  notifyAntwoord() {
    const antwoorden: Antwoord[] = [];
    if (this.vraag && this.vraag.antwoorden) {
      for (const id of this.selectedIds) {
        antwoorden.push(this.vraag.antwoorden.find(a => a.id === id));
      }
    }

    this.setAntwoord(antwoorden, new VraagboomEmptyResultaat());
  }

  antwoordGeselecteerd(antwoord: Antwoord): boolean {
    if (antwoord && this.selectedIds && this.selectedIds.indexOf(antwoord.id) >= 0) {
      return true;
    }
    return false;
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomEmptyResultaat): boolean {
    if (!antwoorden || this.minChoices > antwoorden.length || (this.maxChoices > 0 && antwoorden.length > this.maxChoices)) {
      return false;
    }
    return true;
  }
}
